const LOCAL_KEY = 'adpPayrollPeriods';

export function currentYearMonth() {
  const d = new Date();
  return `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}`;
}

export function formatPeriodCode(code) {
  const s = String(code || '');
  if (/^\d{6}$/.test(s)) return `${s.slice(0, 4)}-${s.slice(4)}`;
  return s || '—';
}

export function loadLocalPeriods() {
  try {
    const raw = localStorage.getItem(LOCAL_KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

export function saveLocalPeriods(list) {
  localStorage.setItem(LOCAL_KEY, JSON.stringify(list));
}

export function mergeLocalPeriods(serverPeriods) {
  const local = loadLocalPeriods();
  if (!local.length) return serverPeriods;
  const seen = new Set(serverPeriods.map((p) => p.code));
  const extras = local.filter((p) => p.code && !seen.has(p.code));
  return extras.length ? [...extras, ...serverPeriods] : serverPeriods;
}
